import { Link } from "react-router-dom";

export default function CriminalHero() {
  return (
    <section className="relative flex min-h-[460px] md:min-h-[540px] items-end justify-center overflow-hidden bg-primary-950">
      <img
        src="/images/bg14.jpg"
        alt="법률 오브제"
        title="법무법인 평율 형사사건"
        className="absolute inset-0 w-full h-full object-cover opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/90 via-primary-900/75 to-primary-950/90"></div>
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-16 left-10 w-72 h-72 rounded-full bg-accent-500 blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-80 h-80 rounded-full bg-accent-500 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-6xl px-4 md:px-6 py-20 md:py-24">
        <nav className="flex items-center gap-2 text-xs text-white/60">
          <Link to="/" className="hover:text-white transition-colors">홈</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-white">형사사건</span>
        </nav>
        <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-medium text-accent-300 tracking-wide">
          <i className="ri-scales-2-line"></i>
          CRIMINAL DEFENSE
        </p>
        <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold text-white leading-tight md:leading-snug">
          광주형사전문<br />
          김평호 변호사
        </h1>
        <p className="mt-5 max-w-2xl text-sm md:text-lg text-white/80 leading-relaxed">
          재판의 흐름을 아는 변호사가 수사부터 재판까지 끝까지 함께합니다.
          <br className="hidden md:block" />
          25년 광주지방법원 부장판사퇴직, 대한변호사협회 등록 형사법전문변호사.
        </p>
      </div>
    </section>
  );
}